import https, { getApiConfig,getQueryString } from '../../utils/request'
import { RequestParams, ContentType, Method } from 'axios-mapper'
import store  from '@/store'
// 计划备货接口 平台接口
/** 平台-查看备货计划列表 */
export const GetPlanList = (data: RequestParams) => {
    const api_config = getApiConfig()
    return https(api_config.liteAdminUrl).request(`/plan-list`, Method.GET, data, ContentType.form)
}
/** 平台-查看计划行变动日志*/
export const GetPlanLog = (data: RequestParams) => {
    const api_config = getApiConfig()
    return https(api_config.liteAdminUrl).request(`/plan-logs`, Method.GET, data, ContentType.form)
}
/**平台-查看仓库列表 */
export const WarehouseList = () => {
    const api_config = getApiConfig()
    return https(api_config.liteAdminUrl).request(`/warehouse-list`, Method.GET)
}
/**平台-查看仓库列表 */
export const ShippingType = () => {
    const api_config = getApiConfig()
    return https(api_config.liteAdminUrl).request(`/shipping-type`, Method.GET)
}
/**平台-查看品类 */
export const GetCategories = (regionId = 6) => {
    const api_config = getApiConfig()
    return https(api_config.liteAdminUrl).request(`/category-list?reginId=${regionId}`, Method.GET)
}
/**平台-查看备货计划上传进度 */
export const LookPlanCheck = (data:RequestParams) => {
    const api_config = getApiConfig()
    return https(api_config.liteAdminUrl).request(`/plan-check?plan_id=${data.planId}`, Method.GET)
}



/** 平台-删除计划备货*/
export const DeletePlan = (data: RequestParams) => {
    const api_config = getApiConfig()
    return https(api_config.liteAdminUrl).request(`/delete-plan`, Method.POST, data)
}

/** 平台-创建/编辑备货计划  传plan_id表示编辑,反之表示创建*/
export const AddRestockPlan = (data: RequestParams) => {
    const api_config = getApiConfig()
    return https(api_config.liteAdminUrl).request(`/save-plan`, Method.POST, data)
}
/** 平台-备货计划邀请商家*/
export const InviteSeller = (data: RequestParams) => {
    const api_config = getApiConfig()
    return https(api_config.liteAdminUrl).request(`/invite-seller`, Method.POST, data)
}
/** 平台-修改备货数量*/
export const ProposalQuantity = (data: RequestParams) => {
    const api_config = getApiConfig()
    return https(api_config.liteAdminUrl).request(`/proposal-quantity`, Method.POST, data)
}
/** 平台-确定最终备货数量*/
export const ConfirmQuantity = (data: RequestParams) => {
    const api_config = getApiConfig()
    return https(api_config.liteAdminUrl).request(`/quantity`, Method.POST, data)
}
/** 平台-计划行锁定*/
export const LockStatus = (data: RequestParams) => {
    const api_config = getApiConfig()
    return https(api_config.liteAdminUrl).request(`/lock-status`, Method.POST, data)
}
/** 平台-备货计划添加备注*/
export const AddRemark = (data: RequestParams) => {
    const api_config = getApiConfig()
    return https(api_config.liteAdminUrl).request(`/add-remark`, Method.POST, data)
}
/** 平台-备货计划行审核*/
export const ChangeStatus = (data: RequestParams) => {
    const api_config = getApiConfig()
    return https(api_config.liteAdminUrl).request(`/change-status`, Method.POST, data)
}
/**平台-查看计划化详情 传plan_id则查询该id的详情,否则查询列表 */
export const GetPlanlTable = (data: RequestParams) => {
    const api_config = getApiConfig()
    return https(api_config.liteAdminUrl).request(`/plan-detail`, Method.POST, data)
}
/**平台-查看计划行统计信息 type为1时查询创建和已邀请的统计,为2时查询已审核和已关闭的统计 */
export const GetPlanlCount = (data: RequestParams) => {
    const api_config = getApiConfig()
    return https(api_config.liteAdminUrl).request(`/plan-count`, Method.POST, data)
}
/**平台-关闭备货计划 */
export const ClosePlan = (data: RequestParams) => {
    const api_config = getApiConfig()
    return https(api_config.liteAdminUrl).request(`/close-plan`, Method.POST, data)
}
/**平台-导出数据 */
export const ExportData = (data: RequestParams) => {
    const api_config = getApiConfig()
    return https(api_config.liteAdminUrl).request(`/export-data`, Method.POST, data)
}
// 平台--获取开放的国家列表
export const GetAdminCountry = () => {
    const api_config = getApiConfig()
    return https(api_config.liteAdminUrl).request(`/localized-subsidiaries/usable`, Method.GET)
}



// 商家端接口
/** 商家-查看备货计划列表*/
export const GetRestockList = (data: RequestParams) => {
    const api_config = getApiConfig()
    return https(api_config.liteSellerUrl).request(`/plan-list`, Method.GET, data, ContentType.form)
}
/**商家-查看备货单列表 */
export const GetSellerStorageList = (data: RequestParams) => {
    const api_config = getApiConfig()
    return https(api_config.liteSellerUrl).request(`/storage-list`, Method.GET, data, ContentType.form)
}
/**商家-查看仓库列表 */
const headers = {
  'Client-Id': 'LOGISTICS-CUSTOMER-PC',
  'X-JWT': getQueryString('token') || store.getters.token
}
export const GetWarehouseList = (region_code: string) => {
    const api_config = getApiConfig()
    return https(api_config.liteSellerStockUrl).request(`/customer/v1/warehouse-authorization/warehouses/usable?regionCode=${region_code}`, Method.GET,{},ContentType.form, {headers})
}
/**商家-查看发货方式列表 */
export const GetShippingType = () => {
    const api_config = getApiConfig()
    return https(api_config.liteSellerUrl).request(`/shipping-type`, Method.GET)
}
/**商家-查看品类 */
export const GetSellerCategories = (regionId) => {
    const api_config = getApiConfig()
    return https(api_config.liteSellerUrl).request(`/categories?regionId=${regionId}`, Method.GET)
}
/**商家-查看备货单列表Lite */
export const GetLiteStorageList = (data: RequestParams) => {
    const api_config = getApiConfig()
    return https(api_config.liteSellerUrl).request(`/stock-items/applications`, Method.GET, data, ContentType.form)
}



/**商家-备货计划审核 */
export const PlanChangeStatus = (data: RequestParams) => {
    const api_config = getApiConfig()
    return https(api_config.liteSellerUrl).request(`/change-status`, Method.POST, data)
}
/**商家-卖家添加备货单 */
export const AddStorage = (data: RequestParams) => {
    const api_config = getApiConfig()
    return https(api_config.liteSellerUrl).request(`/add-storage`, Method.POST, data)
}
/**商家-卖家添加备货计划 */
export const SellerAddRestockPlan = (data: RequestParams) => {
    const api_config = getApiConfig()
    return https(api_config.liteSellerUrl).request(`/add-plan`, Method.POST, data)
}
/**商家-确定可备货数量 */
export const SellerConfirmQuantity = (data: RequestParams) => {
    const api_config = getApiConfig()
    return https(api_config.liteSellerUrl).request(`/quantity`, Method.POST, data)
}
/**商家-删除商家添加的计划行 */
export const SellerDeleteRows = (data: RequestParams) => {
    const api_config = getApiConfig()
    return https(api_config.liteSellerUrl).request(`/delete-rows`, Method.POST, data)
}
/**商家-查看计划行明细 */
export const GetPlanDetail = (data: RequestParams) => {
    const api_config = getApiConfig()
    return https(api_config.liteSellerUrl).request(`/plan-detail`, Method.POST, data)
}
/**商家-查看计划统计信息 */
export const GetSellerPlanCount = (data: RequestParams) => {
    const api_config = getApiConfig()
    return https(api_config.liteSellerUrl).request(`/plan-count`, Method.POST, data)
}
/**商家-卖家查看可选FBK商品 */
export const GetFbkGoods = (data: RequestParams) => {
    const api_config = getApiConfig()
    return https(api_config.liteSellerUrl).request(`/fbk-goods`, Method.GET, data)
}
/**商家-导出数据 */
export const sellerExportData = (data: RequestParams) => {
    const api_config = getApiConfig()
    return https(api_config.liteSellerUrl).request(`/export-data`, Method.POST, data)
}

// 获取商家端开放的国家列表
export const GetSellerCountry = () => {
    const api_config = getApiConfig()
    // stationType 获取国家站的类型(1: 平台能开通的国家站， 2： seller能开通的国家站， 3： store已经开通的国家站）
    return https(api_config.liteSellerUrl).request(`/national-stations?stationType=1`, Method.GET)
}


